import { useEffect, useState } from 'react'
import Axios from 'axios'
import ShipmentDetail from '../Components/ShipmentDetail'
import ShipmentApiDetail from '../Components/ShipmentApiDetail'

const shipmentUrl = process.env.REACT_APP_SHIPMENT_URL

function SearchResult(args) {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
        let url = `${shipmentUrl}/${args.str}/search?delzip=${args.zip}&date=${args.dt}`

        try {
            const response = await Axios.get(url)
    
            if (!response.status === 200)
                throw new Error(
                    `Server request failed. HTTP Status: ${response.status}`)
    
            setItems(response.data)
        }
        catch (error) {
            setError(error)
        }
        finally {
            setLoading(false)
        }
    }

    fetchData()
  }, [])

  if (loading) {
    return <div className="shipment-details">Loading...</div>
  }

  if (error) {
    return <div className="shipment-details text-danger">Error: {error.message}</div>
  }

  if (!(items && items.length)) {
    return <div className="shipment-details">No results found.</div>
  }

  return <div>{
    items.map(item => {
      if (item.target == "api") {
        return (<ShipmentApiDetail key={item.webquotecontrol} item={item} />)
      }
      return (<ShipmentDetail key={item.webquotecontrol} item={item} />)
    })
  }</div>
}

export default SearchResult
